export const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
    ACTIVE: {
        bg: 'bg-green-200 dark:bg-green-900',
        text: 'text-green-700 dark:text-green-200',
    },
    INACTIVE: {
        bg: 'bg-slate-300 dark:bg-slate-900',
        text: 'text-slate-700 dark:text-slate-200',
    },
    APPLIED: {
        bg: 'bg-blue-200 dark:bg-blue-900',
        text: 'text-blue-700 dark:text-blue-200',
    },
    INTERVIEW_1: {
        bg: 'bg-purple-200 dark:bg-purple-900',
        text: 'text-purple-700 dark:text-purple-200',
    },
    INTERVIEW_2: {
        bg: 'bg-purple-200 dark:bg-purple-900',
        text: 'text-purple-700 dark:text-purple-200',
    },
    INTERVIEW_3: {
        bg: 'bg-purple-200 dark:bg-purple-900',
        text: 'text-purple-700 dark:text-purple-200',
    },
    TECHNICAL_TASK_1: {
        bg: 'bg-indigo-300 dark:bg-indigo-900',
        text: 'text-indigo-700 dark:text-indigo-200',
    },
    TECHNICAL_TASK_2: {
        bg: 'bg-indigo-300 dark:bg-indigo-900',
        text: 'text-indigo-700 dark:text-indigo-200',
    },
    OFFER: {
        bg: 'bg-green-200 dark:bg-green-900',
        text: 'text-green-700 dark:text-green-200',
    },
    REJECTED: {
        bg: 'bg-red-200 dark:bg-red-900',
        text: 'text-red-700 dark:text-red-200',
    },
    ARCHIVED: {
        bg: 'bg-slate-200 dark:bg-slate-700',
        text: 'text-slate-700 dark:text-slate-200',
    },
};
